import React from 'react';
import { FaGraduationCap } from 'react-icons/fa';

const Education = () => (
    <div className=" relative backdrop-blur-sm mb-10 z-20 sm:max-w-64 dark:bg-opacity-25   dark:bg-gray-700 p-4 rounded-lg shadow-2xl flex flex-col items-center text-center">
     <div className="flex sm:flex-col items-center space-x-4 sm:space-x-0">
      <img src="/logo.png" alt="Ain Shams University Logo" className=" floatAnimation skeleton mb-4 dark:bg-black bg-white rounded-full skeleton w-28 h-28" />
      <div>
        <h2 className="text-2xl pb-3 font-semibold text-gray-200 dark:text-gray-100">
          Ain Shams University
        </h2>
        <p className="text-lg text-gray-200 dark:text-gray-300">
          Faculty of Engineering, Communication and Electronics Department
        </p>
        <p className="text-lg text-gray-200 dark:text-gray-300">
          GPA: 2.91 (B-)
        </p>
        <a 
          href="https://eng.asu.edu.eg/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green-300 dark:text-blue-300 hover:underline"
        >
          Visit Faculty Website
        </a>
      </div>
    </div>
    <div className="mt-4 flex flex-col items-center text-gray-200 dark:text-gray-300">
      <FaGraduationCap className="text-5xl" />
      <p>Graduated with a Bachelor’s degree in Communication and Electronics Engineering.</p>
    </div>
  </div>
);

export default Education;
